const inputElements = document.querySelectorAll('.FormFileUpload__Input');
const lang = document.documentElement.lang;
const buttonLabel = lang === 'en' ? 'Clear files' : 'Rensa filer';

if (inputElements) {
  inputElements.forEach((inputElement) => {
    inputElement.addEventListener('change', (event) => {
      const fileList = event.target.files;
      const fileNames = Array.from(fileList).map((file) => file.name);
      renderFileNames(fileNames, inputElement);
    });
  });
}


function renderFileNames(fileNames, inputElement) {
  const parentElement = inputElement.parentElement;
  const fileInfoElement = parentElement.querySelector('.file-info');

  if (!fileInfoElement) {
    const newFileInfoElement = document.createElement('div');
    newFileInfoElement.classList.add('file-info');

    fileNames.forEach((fileName) => {
      let paragraphElement = document.createElement('p');
      paragraphElement.textContent = fileName;
      newFileInfoElement.appendChild(paragraphElement);
    });

    if (fileNames.length > 0) {
      // Add remove button
      let removeButton = document.createElement('button');
      removeButton.classList.add('remove-files-button');
      removeButton.innerHTML = `<span>${buttonLabel}</span>`;
      removeButton.addEventListener('click', () => {
        inputElement.value = ''; // Clear the input value
        newFileInfoElement.remove(); // Remove the file info element
      });
      newFileInfoElement.appendChild(removeButton);
    }

    parentElement.appendChild(newFileInfoElement);
  } else {
    fileInfoElement.innerHTML = '';
    fileNames.forEach((fileName) => {
      let paragraphElement = document.createElement('p');
      paragraphElement.textContent = fileName;
      fileInfoElement.appendChild(paragraphElement);
    });

    if (fileNames.length > 0) {
      // Add remove button
      let removeButton = document.createElement('button');
      removeButton.classList.add('remove-files-button');
      removeButton.innerHTML = `<span>${buttonLabel}</span>`;
      removeButton.addEventListener('click', () => {
        inputElement.value = ''; // Clear the input value
        fileInfoElement.remove(); // Remove the file info element
      });
      fileInfoElement.appendChild(removeButton);
    }
  }
}